<template>

  <section class="pb-5 pt-5 nooverflow" style="background: linear-gradient(rgb(255, 255, 255) 30%, #5fcf80 100%);position: relative;" @mouseover="wonderMouseOver" @mouseleave="wonderMouseOut">
			<img src="../../../assets/wondergreen.png" id="wonder" class="wonder wonder-part"/>
			<div class="wonder-part" style="height: 86px;width: 177px;position: absolute;bottom: 40px;transform: skew(-71deg, 7deg);left: 26%;/* bottom: 19px; */z-index: 1;border-radius: 147px;background: rgba(201, 238, 212, 0.14);box-shadow: 0px 14px 18px -5px rgba(39, 97, 57, 0.13);"></div>

			<v-layout column align-center class="pt-3 pb-2" style="position:relative;z-index:2">

				<v-flex xs12 sm4>
					<div class="text-xs-center">
						<h2 class="display-2 font-weight-light mt-5 mb-3">
							How It Works
						</h2>
						<br/>
					</div>
				</v-flex>

				<v-container grid-list-xl class="mt-5">
				<v-layout row  wrap class="mb-5" style="position:relative;z-index:2">
				<div class="try-it-axis hidden-md-and-down"></div>
				<v-flex sm12 lg3>

						<v-layout column align-center>
						<div class="how-it-works-container">
							<v-layout column>
								<v-icon class="how-it-works-icon">touch_app</v-icon>
								<div class="how-it-works-text"><span class="how-it-works-number">1 </span>Login with your GMail account</div>
							</v-layout>
						</div>
						</v-layout>
				</v-flex>
				<v-flex sm12 lg3>
						<v-layout column align-center>
						<div class="how-it-works-container">
							<v-layout column>
								<v-icon class="how-it-works-icon">card_giftcard</v-icon>
								<div class="how-it-works-text"><span class="how-it-works-number">2 </span>Get 100 free words</div>
							</v-layout>
						</div>
						</v-layout>
				</v-flex>
				<!--
				<v-flex sm12 lg4>
						<v-layout column align-center>
						<div class="how-it-works-container">
							<v-layout column>
								<v-icon class="how-it-works-icon">record_voice_over</v-icon>
								<div class="how-it-works-text"><span class="how-it-works-number">3 </span>Select language & character</div>
							</v-layout>
						</div>
						</v-layout>
				</v-flex>
				-->
				<v-flex sm12 lg3>
						<v-layout column align-center>
						<div class="how-it-works-container">
							<v-layout column>
								<v-icon class="how-it-works-icon">movie</v-icon>
								<div class="how-it-works-text"><span class="how-it-works-number">3 </span>Generate your files</div>
							</v-layout>
						</div>
						</v-layout>
				</v-flex>

				<!--
				<v-flex sm12 lg4>
						<v-layout column align-center>
						<div class="how-it-works-container">
							<v-layout column>
								<v-icon class="how-it-works-icon">save_alt</v-icon>
								<div class="how-it-works-text"><span class="how-it-works-number">5 </span>Download them to your device</div>
							</v-layout>
						</div>
						</v-layout>
				</v-flex>
				-->
				<v-flex sm12 lg3>
						<v-layout column align-center>
						<div class="how-it-works-container">
							<v-layout column>
								<v-icon class="how-it-works-icon">accessibility_new</v-icon>
								<div class="how-it-works-text"><span class="how-it-works-number">4 </span>Be Happy</div>
							</v-layout>
						</div>
						</v-layout>
				</v-flex>

				</v-layout>
				</v-container>

				<!--
				<v-flex xs12 sm4 class="mt-5 relative">
					<v-btn class="mt-5 round-button elevation-0" dark large @click='login()' color="rgb(15, 188, 218)" style="box-shadow:-1px 0px 17px -3px rgb(15, 188, 218) !important">See for Yourself</v-btn>
					<img src="../../../assets/hint1.png" style="position: absolute;bottom: 7px;right: -291px;transform: rotate(1deg);"/>
				</v-flex>
					-->
			</v-layout>
			
			<div style="text-align:center;">
				<iframe width="550px" height="315" src="https://www.youtube.com/embed/r0l9JMafpwM" 
					frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="border-radius: 4px;min-width:400px;position:relative;z-index:100;box-shadow: rgba(39, 97, 57, 0.41) 1px 7px 17px -5px;"></iframe>
			
			</div>
			
			<div style="height: 213px;width: 109%;background: white;position: absolute;top: -181px;left: -20px;transform: rotate(178deg);z-index: 1;">.</div>

		</section>


</template>

<style>

@media (max-width: 1520px) {
	.wonder-part {
		display:none !important;
	}
}

@keyframes how-it-works-ani-1 {
  0% {
    transform: scale(1);
  }
  20% {
    transform: scale(1.05);
  }
  40% {
    transform: scale(1.08);
  }
  60% {
    transform: scale(1.1);
  }
  80% {
    transform: scale(1.03);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes wonder-ani {
  0% {
    transform: rotate(0deg);
  }
  40% {
    transform: rotate(-1deg);
  }
  60% {
    transform: rotate(1deg);
  }
  100% {
    transform: rotate(0deg);
  }
}


.wonder {
		position: absolute;
    left: 26%;
    bottom: 66px;
    z-index: 10;
    -webkit-transition: left 0.8s;
    transition: left 0.8s;
    -webkit-animation: wonder-ani 4s infinite !important;
    animation: wonder-ani 4s infinite !important;
    opacity: 1;
	}

	.wonder-active {
		--left:10px !important;
		--animation:wonder-ani 4s infinite !important;
	}

  .how-it-works-icon {
	font-size: 55px !important;
    --color: rgb(255, 143, 84) !important;
    background: #ffffff;
    color: #666666 !important;
    border-radius: 115px;
    height: 165px;
    padding-left: 3.8rem;
    padding-top: 3.3rem;
    box-sizing:border-box;
    margin-left: 28px;
    margin-right: 28px;
    transition:transform 4s;
    box-shadow: 0px 14px 18px -5px rgba(39, 97, 57, 0.13);
}

.how-it-works-container {
	position: relative;
    width: 220px;
    height: 260px;
    background: transparent;
    padding: 30px 10px 10px;
    margin: 0px 1px;
}

.how-it-works-container:hover .how-it-works-text {
	color:#179557 !important;
}

.how-it-works-container:hover  .how-it-works-icon {
    box-shadow:-8px 3px 30px -12px rgba(165, 165, 165, 0.68);
    -webkit-box-shadow:-8px 3px 30px -12px rgba(165, 165, 165, 0.68);
	transform:scale(1.1);
	background:#3abfa0 !important;
	color:white !important;
	transition:transform 0.6s;
}

.how-it-works-text {
	padding-top:28px;
	line-height: 1.5rem;
	text-align:center;
	font-size:1.3rem;
	word-wrap:break-word;
	--color: #f96c22;
}

.how-it-works-number {
	color: #91caa2;
    font-size: 300%;
    position: relative;
    top: 10px;
}

.try-it-axis {
	height: 14px;
	width: 100%;
	background: transparent;
	position: absolute;
	top: 93px;
	z-index: 0;
	border-top:2px dotted rgb(198, 238, 209);
}

</style>

<script>

export default {
  name: "how_it_works_section",
  data() {
    return {
    };
  },
  methods : {
  		wonderMouseOver : function() {
			this.in('wonder', 'wonder-active');
		},
		wonderMouseOut : function() {
			this.out('wonder', 'wonder-active');
		},
  		in : function(id, cls) {
			document.getElementById(id).classList.add(cls);
		},
		out : function(id, cls) {
			document.getElementById(id).classList.remove(cls);
		}
  }
};
</script>
